import { Runnable } from 'src/services/runtime/runnable';
import { execute as executeFlowsteps } from '@v2/services/runtime/flowstepExecution';
import { findFlowsteps } from 'shared/utils/flow';
import office from 'src/services/office';

const Data = {
  BorderFormat: { weight: 'Medium', color: '#000000' },
};

export class Flow extends Runnable {
  constructor(flow, meta) {
    super(meta);
    this.flow = flow;
  }

  get name() { return this.flow.name; }

  async _run_() {
    const { flowsteps, notFound } = findFlowsteps([this.flow], this.officeStore.providerFlowsteps);

    if (!!notFound.size) {
      // TODO:
    }

    const flowstepsResult = await executeFlowsteps(flowsteps, this.meta, this);

    const lastSuccessfullyExecuted = flowstepsResult.flowsteps.find(x => x.result.timestamp);
    const timestamp = lastSuccessfullyExecuted?.result.timestamp ?? '';

    if (this.flow.options.recalculatePivotTables) {
      await office.refreshPivotTables();
    }

    timestamp && await this.setTimestampCellValue(timestamp);
    return { timestamp, ...flowstepsResult };
  }

  async _createLogger_() {
    const props = {
      worksheetName: '',
      name: `Flow '${this.flow.name}'`,
      borderFormat: Data.BorderFormat,
    };

    super.createLogger(props);
  }


  async setTimestampCellValue(ts) {
    const { lastUpdateTimestampCell: cell } = this.flow.options;
    if (!cell) {
      return;
    }
    await super.setTimestampCellValue({ ...cell }, ts);
  }
};


export default Flow;